import { useState } from "react";
import { ArrowUpRight, Check } from "lucide-react";

const fieldSets = {
  planner: ["Event date", "Wedding / event type", "Ceremony / reception location", "Estimated guest count", "Planning service needed", "Budget range"],
  venue: ["Event type", "Preferred date", "Preferred time", "Estimated guest count", "Catering needed?", "Styling needed?", "Indoor / outdoor preference"],
  rental: ["Event date", "Delivery location", "Estimated guest count", "Selected items", "Estimated quantities", "Setup required?"],
};

export default function EventInquiryForm({ business, title = "Tell us what you’re planning." }) {
  const [message, setMessage] = useState("");
  const tagalog = typeof window !== "undefined" && window.localStorage.getItem("mysitecare-language") === "tl";
  const submit = event => {
    event.preventDefault();
    setMessage(tagalog
      ? `Preview lamang ng konsepto — hindi kasalukuyang konektado ang form na ito. Makipag-ugnayan nang direkta kay ${business.name} gamit ang na-verify na detalye sa ibaba.`
      : `Concept preview only — this form is not currently connected. Please contact ${business.name} directly through the verified details below.`);
  };

  return (
    <section className="ev-inquiry" id="inquire">
      <div className="ev-inquiry__intro">
        <p className="ev-kicker">Start the conversation</p>
        <h2>{title}</h2>
        <p>This preview shows the questions an official enquiry could gather. It does not store or transmit anything you enter.</p>
      </div>
      <form onSubmit={submit} className="ev-inquiry__form">
        <div className="ev-inquiry__row">
          <label>Name<input name="name" autoComplete="name" /></label>
          <label>Email or phone<input name="contact" /></label>
        </div>
        <div className="ev-inquiry__fields">
          {fieldSets[business.kind].map(field => <label key={field}>{field}<input name={field.toLowerCase().replace(/\W+/g, "-")} /></label>)}
        </div>
        <label>Tell us about the event<textarea rows="4" name="details" /></label>
        <button type="submit">Preview enquiry <ArrowUpRight size={16} /></button>
        {message && <p className="ev-inquiry__message" role="status"><Check size={16} />{message}</p>}
      </form>
    </section>
  );
}
